// src/services/workflowService.js
import { api } from './apiService';

/**
 * Start a new workflow session
 * @param {string} sessionId - Unique session identifier
 * @param {string} input - User input/intent (required for start action)
 * @returns {Promise<Object>} Response with stage, category, and ICP (if applicable)
 * @example
 * const response = await startWorkflow('abc123', 'find VP of sales currently working for Walmart in Bay Area');
 */
export async function startWorkflow(sessionId, input) {
  try {
    const response = await api.post('/workflow', {
      sessionId,
      action: 'start',
      input
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

/**
 * Approve ICP and continue processing
 * @param {string} sessionId - Unique session identifier
 * @returns {Promise<Object>} Response with stage, sourcingQueries, and results
 * @example
 * const response = await approveWorkflow('abc123');
 */
export async function approveWorkflow(sessionId) {
  try {
    const response = await api.post('/workflow', {
      sessionId,
      action: 'approve'
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}

/**
 * Reject ICP with optional feedback for calibration
 * @param {string} sessionId - Unique session identifier
 * @param {string} [feedback] - Optional feedback for calibration
 * @returns {Promise<Object>} Response with stage and calibrated ICP
 * @example
 * const response = await rejectWorkflow('abc123', 'Prefer payments domain, Bay Area only');
 */
export async function rejectWorkflow(sessionId, feedback) {
  try {
    const response = await api.post('/workflow', {
      sessionId,
      action: 'reject',
      input: feedback || undefined
    });
    return response.data;
  } catch (err) {
    throw err;
  }
}
